<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
    import moment from "moment"
    import {shouldRemoveChachedKey} from "./api"

    export default {
        name: "App",
        mounted(){
            //Cleanup localStorage
            Object.keys(localStorage).forEach(key => {
                if(shouldRemoveChachedKey(key)){
                    try{
                        let item = JSON.parse(localStorage.getItem(key))
                        if(item.loaded) {
                            let hoursOld = moment().diff(moment(item.loaded, "DD.MM.YYYY HH:mm:ss"), 'hours')
                            if(hoursOld > 12) {
                                localStorage.removeItem(key)
                                console.log("Removing old key: " + key)
                            }
                        }
                    } catch(e){
                        //ingore
                    }
                }
            })
        }
    }
</script>